import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

// MODULES
import { FeatureModule } from 'v2/shared/feature/feature.module';
import { ExtraCostsComponent } from 'v2/standalone/extra-costs/extra-costs.component';
import { AlternateIdsComponent } from 'v2/modules/shared/components/alternate-ids/alternate-ids.component';
import { CustomFieldModule } from 'v2/modules/custom-field/custom-field.module';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { FilterModule } from '../filter/filter.module';
import { RfqModule } from '../rfq/rfq.module';
import { SalesOrderLineItemsAssemblyOrderDialogComponent } from '../sales-order/components/sales-order-line-items-assembly-order-dialog/sales-order-line-items-assembly-order-dialog.component';
import { SalesOrderLineItemsTransferOrderDialogComponent } from '../sales-order/components/sales-order-line-items-transfer-order-dialog/sales-order-line-items-transfer-order-dialog.component';
import { OrderAgTableOrderLineItemsComponent } from '../shared/components/order-ag-table-order-line-items/order-ag-table-order-line-items.component';
import { DirectiveModule } from '../shared/directives/directive.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { UiModule } from '../ui/ui.module';

// COMPONENTS

import {
  AssemblyOrderFormTableComponent,
  AssemblyOrderFormComponent,
  AssemblyOrderClosedOrdersTableComponent,
  AssemblyOrderListComponent,
  AssemblyOrderOpenOrdersTableComponent,
  AssemblyOrderStatusCellEditorComponent,
  AssemblyOrderActionCellRendererComponent,
  AssemblyOrderDisassemblyFormTableComponent,
  AssemblyOrderDisassemblyFormComponent,
} from './components';

// MODULES

const components = [
  AssemblyOrderFormTableComponent,
  AssemblyOrderFormComponent,
  AssemblyOrderListComponent,
  AssemblyOrderOpenOrdersTableComponent,
  AssemblyOrderClosedOrdersTableComponent,
  AssemblyOrderStatusCellEditorComponent,
  AssemblyOrderActionCellRendererComponent,
  AssemblyOrderDisassemblyFormTableComponent,
  AssemblyOrderDisassemblyFormComponent,
];

const angularModules = [CommonModule, MaterialCustomModule, AgGridModule];
const lumModules = [
  SharedComponentsModule,
  FormsModule,
  ReactiveFormsModule,
  PipeModule,
  FilterModule,
  UiModule,
  DirectiveModule,
  RouterModule,
  RfqModule,
  FeatureModule,
  CustomFieldModule,
];
const lumStandaloneComponents = [
  ExtraCostsComponent,
  OrderAgTableOrderLineItemsComponent,
  SalesOrderLineItemsTransferOrderDialogComponent,
  SalesOrderLineItemsAssemblyOrderDialogComponent,
  AlternateIdsComponent,
];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [...angularModules, ...lumModules, ...lumStandaloneComponents],
})
export class AssemblyOrderModule {}
